import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { DialogModel } from 'src/app/models/dialog-model';

import { DialogHeaderComponent } from 'src/app/shared/components/dialog-header/dialog-header.component';
import { AppFlatButtonComponent } from '../../buttons/app-flat-button/app-flat-button.component';
import { AppTextButtonComponent } from "../../buttons/app-text-button/app-text-button.component";

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [
        AppFlatButtonComponent,
        AppTextButtonComponent,
        CdkScrollable,
        DialogHeaderComponent,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
    @Input() showCancelButton = true;

    private _routerSubscription: Subscription = new Subscription();

    title: string;
    message: string;
    confirmationActionTitle: string;
    dismissActionTitle: string;

    get hasConfirmationActionTitle(): string {
        if (this.confirmationActionTitle && this.confirmationActionTitle !== '') {
            return this.confirmationActionTitle;
        }

        return 'Yes';
    }

    get hasDismissActionTitle(): string {
        if (this.dismissActionTitle && this.dismissActionTitle !== '') {
            return this.dismissActionTitle;
        }

        return 'Cancel';
    }

    constructor(
        private _router: Router,
        private _dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogModel
    ) {
        this.title = data['dialogData'].title;
        this.message = data['dialogData'].message;
        this.confirmationActionTitle = data['dialogData'].confirmationActionTitle;
        this.dismissActionTitle = data['dialogData'].dismissActionTitle;
    }

    ngOnInit(): void {
        this._routerSubscription = this._router.events.subscribe(() => {
            if (this._dialogRef) {
                this._dialogRef.close();
            }
        });
    }

    ngOnDestroy(): void {
        this._routerSubscription.unsubscribe();
    }

    onConfirmAction(): void {
        this._dialogRef.close(true);
    }

    onCancelAction(): void {
        this._dialogRef.close(false);
    }

}
